import Vue from 'vue'
import VeeValidate,{ Validator } from 'vee-validate'

import zh_CN from 'vee-validate/dist/locale/zh_CN'

const config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'fields',
  i18n: null, // vue-i18n 插件实例
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'zh_CN',
  validity: false
};

setMessage('phone', '手机号码必须是11位', 'password error', (value, [args]) => {
    return value.length == 11 && /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(value)
})

setMessage('name', '姓名只能是长度1-10的中文', 'username no yes', (value, [args]) => {
    const reg = /^([\u4e00-\u9fa5\s])*$/
    return reg.test(value) && (value.length <= 10)
})

// //添加中文检验规则设置
Validator.localize('zh_CN', {
  messages: {
      ...zh_CN.messages, //提示语
      required: (field) => field+"不能为空！",
  },
  attributes: {
    name: '用户名',
    phone: '手机号码',
    phoneCode : '验证码',
    province : '省',
    city : '市',
    area : '区/县',
    house : '地址',
  },
})

function setMessage(validName, errMsgZh, errMsgEn, validate) {
    Validator.locale = 'en'
    Validator.extend(validName, {
      getMessage: (field, [args]) => {
       return errMsgEn
      },
      validate: validate
    })
    Validator.locale = 'zh_CN'
    Validator.extend(validName, {
      getMessage: (field, [args]) => {
        return errMsgZh
      },
      validate: validate
    })
}

Vue.use(VeeValidate, config);




// WEBPACK FOOTER //
// ./src/plugins/validate.js